<template lang="pug">
.t-content
  section.info-sec
    .max-container
      .panelbox
        .panel-holder
          .resbox
            .resbox-con
              .resbox-cusbox.dp.aaa
                .resbox-tabs
                  ul.nav.nav-tabs.s2(role='tablist')
                    li.nav-item(role='presentation' @click="toProfile(0)")
                      button#setProfile-tab.nav-link(data-bs-toggle='tab' data-bs-target='#setProfile' type='button' role='tab' aria-controls='setProfile' aria-selected='true')
                        img(src='/images/menu/a-profile.png')
                        span {{$t('ui.profile')}}
                    //- li.nav-item(role='presentation' @click="changeTab(4)")
                    li.nav-item(role='presentation' @click="$router.push('/statement').catch(err => {})")
                      button#setInbox-tab.nav-link(:class="{'active' : selectedTab === 4}" data-bs-toggle='tab' data-bs-target='#setInbox' type='button' role='tab' aria-controls='setInbox' aria-selected='true')
                        img(src='/images/menu/a-history.png')
                        span {{$t('ui.statement')}}
                    li.nav-item(role='presentation')
                      button#setInbox-tab.nav-link.active(data-bs-toggle='tab' data-bs-target='#setInbox' type='button' role='tab' aria-controls='setInbox' aria-selected='true')
                        img(src='/images/menu/a-inbox.png')
                        span {{$t('ui.inbox')}}
                    li.nav-item(v-if="$store.getters.transaction.length === 0" role='presentation' @click="toProfile(3)")
                      button#setAddBank-tab.nav-link(data-bs-toggle='tab' data-bs-target='#setAddBank' type='button' role='tab' aria-controls='setAddBank' aria-selected='false')
                        img(src='/images/menu/a-bank.png')
                        span {{$t('ui.add_bank')}}
                    li.nav-item(v-if="$store.getters.transaction.length > 0" role='presentation' @click="toProfile(1)")
                      button#setBankDetail-tab.nav-link(:class="{'active' : selectedTab === 1}" data-bs-toggle='tab' data-bs-target='#setBankDetail' type='button' role='tab' aria-controls='setBankDetail' aria-selected='false')
                        img(src='assets/img/bank/m-bank-d.png')
                        span  {{$t('ui.bank_detail')}}
                    li.nav-item(role='presentation' @click="toProfile(2)")
                      button#setChangePassword-tab.nav-link(data-bs-toggle='tab' data-bs-target='#setChangePassword' type='button' role='tab' aria-controls='setChangePassword' aria-selected='false')
                        img(src='/images/menu/a-password.png')
                        span {{$t('ui.change_password')}}
                  .tab-content
                    inbox(v-if="selectedTab === 0")
//- #setInbox.inbox.tab-pane.fade.show.active(role='tabpanel' aria-labelledby='ppg-tab')
  ul.nav.nav-tabs(role='tablist')
    li.nav-item(role='presentation' @click="changeTab(0)")
      button#inbox-tab.nav-link(:class="{'active': selectedTab === 0}" data-bs-toggle='tab' data-bs-target='#inbox' type='button' role='tab' aria-controls='inbox' aria-selected='true') {{$t('ui.inbox')}}
    //- li.nav-item(role='presentation' @click="changeTab(1)")
      button#game-rebate-tab.nav-link(:class="{'active': selectedTab === 1}" data-bs-toggle='tab' data-bs-target='#game-rebate' type='button' role='tab' aria-controls='game-rebate' aria-selected='false') {{$t('ui.daily_rebate')}}
  .tab-content
    inbox(v-if="selectedTab === 0")
    //- self(v-if="selectedTab === 1")
</template>
<script>
// import self from '@/components2/referral/_self.vue'
import inbox from '@/views/default/_inbox.vue'
export default {
  components:{
    inbox,
    // self
  },
  data(){
    return{
      selectedTab: 0,
    }
  },
  mounted(){
    window.scroll(0,0)
  },
  methods:{
    toProfile(target){
      this.$router.push({
        name:"profile",
        params:{
          "option": target
        }
      }).catch(error =>{})
    },
  }
}
</script>